module.exports = __webpack_public_path__ + "img/上海依工.png";